import InviteToAppStatus from '@opsbase/lib-auth/InviteToAppStatus';
import StaffUserType from '@opsbase/lib-auth/StaffUserType';
import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import Palette from '@opsbase/lib-palette';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import SelectionToolbar from '@opsbase/web-data-selection/SelectionToolbar';
import useSelection from '@opsbase/web-data-selection/useSelection';
import DeleteIcon from '@opsbase/web-icons/icons/DeleteIcon';
import EditIcon from '@opsbase/web-icons/icons/EditIcon';
import EmailIcon from '@opsbase/web-icons/icons/EmailIcon';
import useNav from '@opsbase/web-nav/useNav';
import React, { useCallback, useMemo } from 'react';
export function StaffSelectionToolbar() {
    const self = useSelf();
    const dataType = DataType.STAFF;
    const { selecteds } = useSelection(dataType);
    const { goTo } = useNav();
    const handleClickEdit = useCallback(() => {
        goTo(Pages.STAFF_MULTI_EDIT, { id: 'selected' });
    }, [goTo]);
    const handleClickDelete = useCallback(() => {
        goTo(Pages.STAFF_DELETE, { id: 'selected' });
    }, [goTo]);
    const handleClickSendInvite = useCallback(() => {
        goTo(Pages.STAFF_INVITE, { id: 'selected' });
    }, [goTo]);
    const isSelfSelected = selecteds.some(s => s.id === self.id);
    const isPrimarySelected = selecteds.some(s => s.staffType === StaffUserType.PRIMARYADMIN);
    const isEveryoneAVirgin = selecteds.every(s => s.inviteToAppStatus !== InviteToAppStatus.LOGGEDIN);
    const canInviteToApp = !isSelfSelected && isEveryoneAVirgin;
    const canEdit = !isSelfSelected && !isPrimarySelected;
    const handleClickDisable = useCallback(() => {
        goTo(Pages.STAFF_DISABLE, { id: 'selected' });
    }, [goTo]);
    const handleClickEnable = useCallback(() => {
        goTo(Pages.STAFF_ENABLE, { id: 'selected' });
    }, [goTo]);
    const actions = useMemo(() => [
        {
            label: i18n.t('delete'),
            Icon: DeleteIcon,
            color: Palette.error,
            disabled: !canEdit,
            onClick: handleClickDelete,
        },
        {
            label: i18n.t('edit'),
            Icon: EditIcon,
            color: Palette.secondary,
            disabled: !canEdit,
            onClick: handleClickEdit,
        },
        {
            label: i18n.t('invite-to-app'),
            Icon: EmailIcon,
            color: Palette.PastelBlue,
            disabled: !canInviteToApp,
            onClick: handleClickSendInvite,
        },
        {
            label: i18n.t('disable'),
            color: Palette.secondary,
            onClick: handleClickDisable,
        },
        {
            label: i18n.t('enable'),
            color: Palette.secondary,
            onClick: handleClickEnable,
        },
    ], [canEdit, handleClickDelete, handleClickEdit, handleClickSendInvite, canInviteToApp, handleClickDisable, handleClickEnable]);
    return React.createElement(SelectionToolbar, { dataType: dataType, actions: actions });
}
export default StaffSelectionToolbar;
